/* 请求方式的再封装，如果不希望对接口错误做定制处理，采用此种方式把错误toast即可 */
import { domain } from '@finance/domain'
import ajax from '@finance/ajax'
import Toast from '@common/toast'
import store from '$stores/index'

const Loading = {
  count: 0,
  show() {
    this.count++
    if (this.count > 0) {
      store.commit('showLoading')
    }
  },
  hide() {
    this.count--
    if (this.count === 0) {
      store.commit('hideLoading')
    }
  }
}

interface IRequestConfig {
  loading?: boolean;
  retry?: boolean;
  retryNum?: number;
  showError?: boolean;
}

const request = (
  url: string,
  body: object = {},
  {
    loading = true,
    retry = false,
    retryNum = 1,
    showError = true
  }: IRequestConfig = {}
): Promise<any> => {
  loading && Loading.show()

  return ajax.request({
    url: domain.api + url,
    body
  }).then((result) => {
    loading && Loading.hide()

    if (!result.succeed) {
      return Promise.reject(result)
    }
    return result.data
  }).catch((result) => {
    console.error(url, result)
    loading && Loading.hide()

    if (retry && retryNum < 3) {
      return request(url, body, { loading, retry, retryNum: retryNum + 1 })
    } else {
      const msg = result.message || result.msg || result
      showError && Toast(msg)
    }
    return Promise.reject(result)
  })
}

export default request
